// extracted by mini-css-extract-plugin
module.exports = {"inlineEdit":"inlinecheckbox_inlineEdit__3noiR","inlineEditCheckWrapper":"inlinecheckbox_inlineEditCheckWrapper__2nKP5","inlineEditCheck":"inlinecheckbox_inlineEditCheck__2DF1j"};